var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayersActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.913 3.26 9.006 1.52c-.573-.253-1.44-.253-2.013 0L3.086 3.26C2.1 3.7 1.953 4.3 1.953 4.62s.147.92 1.133 1.36l3.907 1.74c.287.127.647.193 1.007.193s.72-.066 1.006-.193l3.907-1.74c.987-.44 1.133-1.04 1.133-1.36s-.14-.92-1.133-1.36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 11.36c-.253 0-.506-.053-.74-.153l-4.493-2c-.687-.307-1.22-1.127-1.22-1.88a.492.492 0 1 1 .987 0c0 .36.3.826.633.973l4.493 2c.214.093.46.093.674 0l4.493-2c.333-.147.633-.607.633-.973a.492.492 0 1 1 .987 0c0 .746-.533 1.573-1.22 1.88l-4.493 2c-.227.1-.48.153-.734.153"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 14.667c-.253 0-.506-.054-.74-.154l-4.493-2a2.06 2.06 0 0 1-1.22-1.88.492.492 0 1 1 .987 0c0 .42.246.8.633.974l4.493 2c.214.093.46.093.674 0l4.493-2a1.07 1.07 0 0 0 .633-.974.492.492 0 1 1 .987 0c0 .814-.48 1.547-1.22 1.88l-4.493 2c-.227.1-.48.154-.734.154"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersActive);
export default __webpack_public_path__ + "static/media/layersActive.309ef5416be6b871069e6873a1bfd2cd.svg";
export { ForwardRef as ReactComponent };